import React, { useEffect, useState } from "react";
import LeftMenu from "../AnalyticsModule/Left";
import "./enableDisable.css";
import Button from "../../library/components/Button";
import { useGetBallotVerificationACMutation } from "../../services/announceElection";
import { RunnerUpHeader } from "../../ui";
import SubLeftMenu from "../AnalyticsModule/SubLeft";
const EnableVerificationBallot = () => {
  const [state, setState] = useState();
  const [getData, datap] = useGetBallotVerificationACMutation();
  const [switchTabs, setswitchTabs] = useState("AC");
  useEffect(() => {
    getData({
      constType: "AC",
      constNo: "",
      flag: "",
    });
  }, []);

  useEffect(() => {
    const Aclist = [];
    if (datap.isSuccess) {
      console.log(datap);
      datap?.data?.payload?.map((item) => {
        Aclist.push({
          flag: item?.flag,
          AC: item?.constNo,
          AcName: item?.constName,
          constType: item?.constType,
          finalizeBallotPath: item?.finalizeBallotPath,
        });
      });
    }
    setState(Aclist);
  }, [datap.isSuccess]);

  const handleChange = (e, id) => {
    const newState = state.map((obj) => {
      if (obj.AC == id) {
        return {
          ...obj,
          flag:
            e.target.value === "enable"
              ? "true"
              : e.target.value === "disable"
              ? "false"
              : "true",
        };
      }
      return obj;
    });
    setState(newState);
  };

  const handleUpdate = (ac, flag, constType) => {
    getData({
      constType: constType,
      constNo: ac,
      flag: flag,
    });
  };

  const switchTab = (data, e) => {
    getData({
      constType: data,
      constNo: "",
      flag: "",
    });
    setswitchTabs(data);
    console.log(e);
  };
  return (
    <SubLeftMenu>
      <div className="container box shadow ">
      <div className="checkboxHeader">
        <p className="text-center checkboxHead">
          Ballot Verification Enable/Disable Operation
        </p>
      </div>
      <div className="row checkboxHeaderButton">
        <div className="col-md-6" style={{ paddingLeft: "0px" }}>
          <p
            className={`text-center ${
              switchTabs === "AC" ? `checkboxChecked` : `checkboxUnChecked`
            }`}
            onClick={(e) => {
              switchTab("AC", e);
            }}
          >
            Assembly Constituency
          </p>
        </div>
        <div className="col-md-6" style={{ paddingRight: "0px" }}>
          <p
            className={`text-center ${
              switchTabs === "PC" ? `checkboxChecked` : `checkboxUnChecked`
            }`}
            onClick={() => {
              switchTab("PC");
            }}
          >
            Parliamentary Constituency
          </p>
        </div>
      </div>
      <div className="row checkbox_header">
        <div className="col-md-5">
          <p className="checkboxAcLabel">
            {" "}
            {switchTabs === "AC"
              ? "Assembly Constituency"
              : "Parliamentary Constituency"}
          </p>
        </div>
        <div
          className="col-md-4"
          style={{
            display: "flex",
            maxWidth: "17em",
            justifyContent: "space-between",
            marginLeft: "19px",
          }}
        >
          <p className="checkboxAcLabel">Enable</p>
          <p className="checkboxAcLabel">Disable</p>
        </div>
      </div>
      {state?.map((item, i) => {
        return (
          <div className="row checkboxEnableDisableRow" id={i}>
            <div className="col-md-5">
              <p className="checkboxAcList">
                {item?.AC} - {item?.AcName}
              </p>
            </div>
            <div className="checkboxEnableDisable col-md-4">
              <label
                for={i + "a"}
                style={{
                  cursor: `${
                    item?.finalizeBallotPath === null ? null : "not-allowed"
                  }`,
                }}
              ></label>
              <input
                className="firstInput"
                checked={item?.flag === "false" ? false : true}
                disabled={item?.finalizeBallotPath === null ? false : true}
                id={i + "a"}
                style={{
                  cursor: `${
                    item?.finalizeBallotPath === null ? null : "not-allowed"
                  }`,
                }}
                type="radio"
                name={i}
                value="enable"
                onChange={(e) => handleChange(e, item?.AC)}
              />
              <label
                for={i + "b"}
                style={{
                  cursor: `${
                    item?.finalizeBallotPath === null ? null : "not-allowed"
                  }`,
                }}
              ></label>
              <input
                className="firstInput"
                checked={item?.flag === "true" ? false : true}
                disabled={item?.finalizeBallotPath === null ? false : true}
                id={i + "b"}
                style={{
                  cursor: `${
                    item?.finalizeBallotPath === null ? null : "not-allowed"
                  }`,
                }}
                type="radio"
                name={i}
                value="disable"
                onChange={(e) => handleChange(e, item?.AC)}
              />
              <span></span>
            </div>
            <div className="offset-md-1 col-md-2">
              {item?.finalizeBallotPath === null ? (
                <Button
                  value="Submit"
                  btnClass=" checkbox_screen_button button_popup_screen"
                  // disabled={item?.finalizeBallotPath === null? false:true}
                  onClick={() => {
                    handleUpdate(item?.AC, item?.flag, item?.constType);
                  }}
                />
              ) : (
                <p
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "red",
                  }}
                >
                  Ballot paper already uploaded and finalzied
                </p>
              )}
            </div>
          </div>
        );
      })}
      </div>
    </SubLeftMenu>
  );
};

export default EnableVerificationBallot;
